import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=c44de092&scoped=true"
import script from "./AboutMe.vue?vue&type=script&lang=js"
export * from "./AboutMe.vue?vue&type=script&lang=js"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=c44de092&prod&lang=scss&scoped=true"
import style1 from "./AboutMe.vue?vue&type=style&index=1&id=c44de092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44de092",
  null
  
)

export default component.exports